export class TipDetails {
  id: number = -1;

  tipId: number = -1;

  licenceNumber: string = '';
  carrierLicenceNumber: string = '';
  carrierLicenceExpiryDate: string = '';

  createdAt: string = '';
  updatedAt: string = '';
}
